import { useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { AppFooter } from '../branding/AppFooter';
import { AppHeader } from '../branding/AppHeader';
import { useConsumeMagicLink } from './useAuth';
import './AuthDialog.css';

export function MagicLinkPage(): JSX.Element {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const consume = useConsumeMagicLink();

  useEffect(() => {
    if (token && consume.isIdle) {
      consume.mutate({ token });
    }
  }, [consume, token]);

  useEffect(() => {
    if (consume.isSuccess) {
      const t = window.setTimeout(() => navigate('/studio', { replace: true }), 800);
      return () => window.clearTimeout(t);
    }
    return undefined;
  }, [consume.isSuccess, navigate]);

  return (
    <>
      <AppHeader />
      <main className="bl-auth" style={{ margin: '2rem auto' }}>
        <h1 className="bl-auth__title">Opening your studio</h1>
        {!token && (
          <p className="bl-auth__error" role="alert">
            This sign-in link is missing its token. Ask for a fresh one from the sign-in
            screen.
          </p>
        )}
        {token && consume.isPending && (
          <p className="bl-auth__sent" role="status">
            Checking your link…
          </p>
        )}
        {consume.isSuccess && (
          <p className="bl-auth__sent" role="status">
            You&apos;re signed in. Taking you to the studio…
          </p>
        )}
        {consume.error && (
          <p role="alert" className="bl-auth__error">
            {consume.error.message}
          </p>
        )}
        <p>
          <Link to="/">Back home</Link>
        </p>
      </main>
      <AppFooter />
    </>
  );
}
